import _ from 'lodash'

function fetchOnce(context, once, next, property_name, func) {
  if (once === true) {
    if (_.get(context.rootState.fetched, property_name, false)) {
        // log.debug(`Not going to fetch ${property_name} more than once`)
      if (next) {
        next();
      }
      return Promise.resolve()
    }
  }

  return func().then(() => {
    context.commit('SET_FETCHED', property_name);
  });
}

export {
  fetchOnce
}
